import { render } from "./Interview.vue?vue&type=template&id=13ddb504&scoped=true"
import script from "./Interview.vue?vue&type=script&lang=js"
export * from "./Interview.vue?vue&type=script&lang=js"

import "./Interview.vue?vue&type=style&index=0&id=13ddb504&scoped=true&lang=css"

import exportComponent from "E:\\work\\code\\ai-view\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ddb504"]])

export default __exports__